import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';
import type { LaunchOption, LaunchParams } from '@/hooks/useLauncher';
import type { PlatformTypes } from '@/types/gql.generated';
import type { LaunchReason } from './types';

type OpenFn = (args?: {
  reason: LaunchReason;
  platform?: PlatformTypes | null;
  launch?: LaunchOption;
  launchParams?: LaunchParams;
  resetOnSuccess?: boolean;
  onSuccess?: () => void;
}) => void;

type State = {
  isOpen: boolean;
  platform: PlatformTypes | null;
  reason: LaunchReason | null;
  launch: LaunchOption | null;
  launchParams: LaunchParams | null;
  open: OpenFn;
  close: () => void;
  onSuccess: (() => void) | null;
  resetOnSuccess: boolean;
};

export const useAuthModal = createWithEqualityFn<State>()(
  (set) => ({
    isOpen: false,
    platform: null,
    reason: null,
    launch: null,
    launchParams: null,
    onSuccess: null,
    resetOnSuccess: false,
    open: (args) => {
      const platform = args?.platform ?? null;
      const reason = args?.reason ?? null;
      const launch = args?.launch ?? null;
      const launchParams = (launch && args?.launchParams) || null;
      const onSuccess = args?.onSuccess ?? null;
      const resetOnSuccess = args?.resetOnSuccess ?? false;
      set({
        platform,
        reason,
        launch,
        launchParams,
        onSuccess,
        resetOnSuccess,
        isOpen: true,
      });
    },
    close: () =>
      set({
        isOpen: false,
        onSuccess: null,
        launch: null,
        launchParams: null,
        reason: null,
        resetOnSuccess: false,
      }),
  }),
  shallow
);
